import { render, staticRenderFns } from "./whWasteStat.vue?vue&type=template&id=4d5223b2&scoped=true&"
import script from "./whWasteStat.vue?vue&type=script&lang=js&"
export * from "./whWasteStat.vue?vue&type=script&lang=js&"
import style0 from "./whWasteStat.vue?vue&type=style&index=0&id=4d5223b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5223b2",
  null
  
)

component.options.__file = "whWasteStat.vue"
export default component.exports